/** EventSource URL for inspiration gallery ZIP processing progress */
export function getInspirationGalleryUploadProgressUrl(uploadId) {
    const base =
        process.env.REACT_APP_URL ||
        process.env.REACT_APP_DEFAULT_WORKSPACE ||
        ''
    const normalized = String(base).replace(/\/$/, '')
    return `${normalized}/backend/inspiration-gallery/upload-progress/${uploadId}`
}
